import { FC, useState } from 'react';
import {
  cvaBadge,
  cvaBadgeName,
  cvaBadgePhone,
} from '~/entities/Badge/BadgeStyle';
import { EditProfile } from '~/pages/ProfilePage/ui/EditProfile/EditProfile';
import { Portal } from '~/shared/ui/Portal/Portal';
import { formatPhoneNumber } from '~/shared/utils/phoneFormatter';

interface Props {
  name: string;
  phone: string;
}
export const Badge: FC<Props> = ({ name, phone }) => {
  const phoneNumber = formatPhoneNumber(phone);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className={cvaBadge()}>
        <h2 className={cvaBadgeName()} onClick={() => setIsOpen(true)}>
          {name}
        </h2>
        {<span className={cvaBadgePhone()}>{phoneNumber}</span>}
      </div>
      {isOpen && (
        <Portal>
          <EditProfile open={isOpen} onClose={() => setIsOpen(false)} />
        </Portal>
      )}
    </>
  );
};
